<div class="container">
  <h1 class="page-title">修正報關單價</h1>
  <div class="mt-2">
    <h3>檔案</h3>
    <div class="container">
      <div class="p-fluid grid">
          <div class="field col-12">
            <p-fileUpload #fileUpload [customUpload]="true" (uploadHandler)="fileUploader($event)" chooseLabel="選擇" uploadLabel="匯入" cancelLabel="取消" accept=".xls,.xlsx">
              <ng-template pTemplate="toolbar">
                <button pButton pRipple label="範本下載" (click)="templateDownloadClickBtn($event)" class="ml-2"></button>
              </ng-template>
            </p-fileUpload>
          </div>
      </div>
    </div>
    <div class="mt-2">
      <laas-data-table [tableKey]="preferenceKey" [selectable]="false" [dataKey]="'seqNo'" [value]="warehousingRMBPriceRows" [defaultColumns]="columns" [loading]="isLoading">
        <ng-template pTemplate="caption">
          <button pButton pRipple label="上傳" [disabled]="warehousingRMBPriceRows.length === 0" (click)="importClickBtn($event)" class="ml-2"></button>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </div>
</div>
